/* custom selects */
(function($) {  
  $(function() {  
    $('.header_currency select, #navigation select').styler();
    $('.jq-selectbox__trigger').append('<i class="fa fa-caret-down"></i>');
  });
})(jQuery)



jQuery(function($){

  $('html').removeClass('no-js'); 

  $('ul.styles > li').click(function(){
      var className = $(this).attr('class');
      $('body').removeClass('theme-style-0 theme-style-1 theme-style-2 theme-style-3');
      $('body').addClass(className);
    });

  $('li:last-child, .product-listing > div:last-child').addClass('lastItem');
  $('li:first-child, .product-listing > div:first-child').addClass('firstItem');


  /* Dropdown menu */
  $('ul.sf-menu').supersubs({
      minWidth:    12,   // minimum width of submenus in em units
      maxWidth:    27,   // maximum width of submenus in em units
      extraWidth:  1     // extra width can ensure lines don't sometimes turn over
                               // due to slight rounding differences and font-family
    }).superfish({
      animation: { height: 'show' }, // slide-down animation
      speed: 'fast' // faster animation speed
  });

  var ismobile = navigator.userAgent.match(/(iPhone)|(iPod)|(android)|(webOS)/i)
    if(ismobile){
      $('.sf-menu').sftouchscreen();
    }


  /* mobile menu */
  $("#mobile_menu").change(function(){ window.location = jQuery(this).val(); });


  /* custom selects 
  $('.jq-selectbox__trigger').append('<i class="fa fa-caret-down"></i>'); */


  /* Placeholder JS */
  /*==========================*/

  $('[placeholder]').each(function(){
    if ($(this).val() === '') {
      var hint = $(this).attr('placeholder');
      $(this).val(hint).addClass('hint');
    }
  });

  $('[placeholder]').focus(function() {
    if ($(this).val() === $(this).attr('placeholder')) {
      $(this).val('').removeClass('hint');
    }
  }).blur(function() {
    if ($(this).val() === '') {
      $(this).val($(this).attr('placeholder')).addClass('hint');
    }
  });                    

  /* Form validation JS */
  /*==========================*/

  $('input.error, textarea.error').focus(function() {
    $(this).removeClass('error');
  });

  $('form :submit').click(function() {
    $(this).parents('form').find('input.hint, textarea.hint').each(function() {
      $(this).val('').removeClass('hint');
    });
    return true;
  });

   
   /* form styles */  
  $('.address_table form, .customer_address form').addClass('form-horizontal');


  /* alerts */
  $('.template-customers-login, #create_customer').find('.errors').addClass('alert').addClass('alert-danger');


  /* stick menu */
  $(document).ready(function(){
  $('#navigation').tmStickUp({});
  })


  /* scroll animation */
  if (!($.browser.msie && $.browser.version == 8.0 || $(window).width() <= 1200)) {
    new WOW().init();
  };

  $(".page_heading").wrapInner("<span class='new'></span>");
  
  $(".compare-at-price").prev().addClass("new");

});
